import formatName from 'I18n/utils/formatName';
import { slugify } from './utils';
export const redirectTo = url => {
  window.location.href = url;
};
export const getAchievementUrlSlug = ({
  firstName,
  lastName,
  trackName
}) => {
  const userSlug = slugify(formatName({
    firstName,
    lastName
  }));
  const trackSlug = slugify(trackName);
  if (!userSlug) {
    return trackSlug;
  }
  if (!trackSlug) {
    return userSlug;
  }
  return `${userSlug}/${trackSlug}`;
};